import React from "react";

class CharacterForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      additionalComment: props.initialState
        ? props.initialState.additionalComment
        : undefined,
      knownFor: props.initialState ? props.initialState.knownFor : "",
      refereeName: props.initialState ? props.initialState.refereeName : "",
      refereePosition: props.initialState
        ? props.initialState.refereePosition
        : ""
    };

    this.handleInputChange = this.handleInputChange.bind(this);
    this.sendReference = this.sendReference.bind(this);
  }

  handleInputChange(event) {
    const { value, name } = event.target;
    this.setState({
      [name]: value
    });
  }

  sendReference(event) {
    event.preventDefault();
    const data = {
      reference: { ...this.state, referenceType: "character" }
    };
    this.props.saveReference(data);
  }

  TextInput(props) {
    return (
      <div className="form-group">
        <label htmlFor={props.id}>{props.label}</label>
        <input
          type="text"
          className="form-control"
          id={props.id}
          name={props.id}
          value={props.value}
          onChange={this.handleInputChange}
          required={props.required}
          readOnly={props.readOnly}
        />
      </div>
    );
  }

  render() {
    return (
      <form onSubmit={this.sendReference}>
        <div className="form-group">
          <label htmlFor="additionalComment">
            Please confirm that you personally know the person of whom you are
            writing this character reference for and comment on traits such as
            reliability, commitment, integrity and general character*
          </label>
          <textarea
            className="form-control"
            id="additionalComment"
            name="additionalComment"
            value={this.state.additionalComment}
            onChange={this.handleInputChange}
            rows={5}
            required={true}
          ></textarea>
        </div>
        {this.TextInput({
          id: "knownFor",
          label:
            "How long have you known the person of whom you are writing this character reference for?",
          value: this.state.knownFor,
          required: false
        })}
        {this.TextInput({
          id: "refereeName",
          label: "Your name*",
          value: this.state.refereeName,
          required: true
        })}
        {this.TextInput({
          id: "refereePosition",
          label: "Your position*",
          value: this.state.refereePosition,
          required: true
        })}
        <div className="text-center">
          <button className="btn btn-primary" type="submit">
            Submit Reference
          </button>
        </div>
      </form>
    );
  }
}

export default CharacterForm;
